import { animate, state, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectionStrategy, Component, computed, HostBinding, OnInit,
} from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { RouterLink } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule, DisabledDirective, FroalaModule, IconModule, SafeUrlPipe,
} from '@hglobal/common';
import { CoinComponent, ConfettiComponent } from '@pt/components';
import { environment } from '@pt/environment';
import { UserMentoringTaskDetail } from '@pt/models';

import {
  MyMentoringApiMocks,
} from '../../../../../../apps/site/src/app/pages/my-mentoring/api/my-mentoring-api.mocks';
import {
  MyMentoringApiService,
} from '../../../../../../apps/site/src/app/pages/my-mentoring/api/my-mentoring-api.service';
import { TASK_DETAILS_API, TaskDetailsBaseComponent }
  from '../abstructions/task-details-base.component';

const CompletedIconAnimation = trigger('completedIcon', [
  state('notCompleted', style({ opacity: 0, transform: 'rotate(-45deg) scale(2)' })),
  state('completed', style({ opacity: 1 })),
  transition('notCompleted => completed', animate('100ms')),
]);

@Component({
  imports: [
    IconModule,
    ButtonModule,
    TranslateModule,
    ReactiveFormsModule,
    SafeUrlPipe,
    FroalaModule,
    MatSlideToggle,
    DisabledDirective,
    CoinComponent,
    RouterLink,
    ConfettiComponent,
  ],
  providers: [
    {
      provide: TASK_DETAILS_API,
      useClass: environment.useMocks
        ? MyMentoringApiMocks
        : MyMentoringApiService,
    },
  ],
  selector: 'pt-mentoring-task-details',
  templateUrl: './mentoring-task-details.component.html',
  styleUrls: ['./mentoring-task-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [CompletedIconAnimation],
})
export class MentoringTaskDetailsComponent
  extends TaskDetailsBaseComponent<UserMentoringTaskDetail>
  implements OnInit {
  @HostBinding('class.pt-onboarding-task-details_completed') get isTaskCompleted() {
    return this.isCompleted();
  }

  taskConfirmationType = computed(() => this.task().confirmationType);

  override taskBtnKey = computed(() => {
    if (this.taskConfirmationType() === 'auto') {
      return `onboardingTask.btn.goTo.${this.task().entity.entityType}`;
    }

    return '';
  });

  override autoTaskLink = computed(() => {
    if (this.taskConfirmationType() === 'auto') {
      switch (this.task().entity!.entityType) {
        case 'quest':
          return ['/quests', this.userLocationId(), 'quest', this.task().entity.id];
        case 'course':
          return ['/education/courses', this.task().entity.id];
      }
    }

    return [];
  });
}
